<ng-container *transloco="let t; read:'permit.signature'">
    <div class="modal">
        <div class="modal__content">
            <signature-pad *ngIf="signaturePadOptions" class="modal__content__signature" #signature [options]="signaturePadOptions"
                           (drawStart)="drawStart($event)" (drawEnd)="drawComplete($event)"></signature-pad>

            <div class="modal__content__details">
                <div class="modal__content__details__name-and-clear">
                    <div class="modal__content__details__name-and-clear__name">
                        {{ data.person.firstName }} {{ data.person.lastName }}
                    </div>
                    <button class="modal__content__details__name-and-clear__clear-button" (click)="clear()">{{ t("clear") }}</button>
                </div>
                <div class="modal__content__details__disabled-firealarm" *ngIf="data.disabledFireAlarm">
                    <ha-checkbox [(ngModel)]="disabledFireAlarmRestored" [ngModelOptions]="{standalone: true}"
                                 [label]="t('disabledFireAlarm', { alarm: data.disabledFireAlarm })">
                    </ha-checkbox>
                </div>
                <div class="modal__content__divider"></div>
                <form [formGroup]="endPermitForm">
                    <div class="modal__content__details__comment">
                        <ha-input formControlName="comment"
                               [label]="t('endComment')" [required]="data.permitEndCommentRequired">
                        </ha-input>
                    </div>
                    <div class="modal__content__details__photo">
                        <div *ngIf="data.permitEndPhotoRequirement === photoRequirement.Required && (photos$ | async).length < 1" class="modal__content__details__photo-required">{{ t("photoRequired") }}</div>
                        <div *ngIf="data.permitEndPhotoRequirement === photoRequirement.Prohibited" class="modal__content__details__photo-prohibited">
                            {{ t(data.isDemo ? "demoPhoto" : "photoProhibited") }}</div>
                        <div *ngIf="data.permitEndPhotoRequirement !== photoRequirement.Prohibited" class="modal__content__details__photo-warning">{{ t("photoWarning") }}</div>
                        <input class="modal__content__details__photo__file-input" type="file" multiple #fileInput (change)="processSelectedImages(fileInput)" accept="image/*" [required]="data.permitEndPhotoRequirement === photoRequirement.Required" />
                        <button (click)="fileInput.click()" class="modal__content__details__photo__upload-button" [class.modal__content__details__photo__upload-button--disabled]="data.permitEndPhotoRequirement === photoRequirement.Prohibited" [loading]="savePermitPhotoAction">
                            {{t((photos$ | async)?.length > 0 ? "addAdditionalPhoto" : "addPhoto") }}
                        </button>
                        <div class="modal__content__details__photo__list" *ngIf="photos$ | async as photos">
                            <div *ngFor="let photo of photos" class="modal__content__details__photo__list__item">
                                <img class="modal__content__details__photo__list__item__image" [src]="photo.url" alt="End photo" />
                                <button class="modal__content__details__photo__list__item__remove" (click)="removePhoto(photo.guid)">
                                    <p></p>
                                </button>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
        </div>

        <div class="modal__actions">
            <button class="modal__actions__close" type="button" (click)="closeModal()">{{ t("cancel") }}</button>
            <button class="modal__actions__save" [class.modal__actions__save--disabled]="!isValid" [loading]="endPermitWithSignatureAction" type="button" (click)="endPermit()">
                {{ t("endPermit")}}
            </button>
        </div>
    </div>
</ng-container>
